// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@adl/XDL/types";
import { color } from "@adl/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 12,
            color: "text",
            ellipsis: true,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                margin-bottom: 5px;
                max-width: 100ch;
            `,
        },
        css: css`
            flex-wrap: wrap;
            ${StyledButton} {
                position: relative;
                overflow: hidden;
            }
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("text")};
            }

            ${StyledButton} > ${TypographyStyle}:after {
                content: '';
                position: absolute;
                bottom: 4px;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: ${color("text.main")};
                opacity: 0;
                transition: opacity 300ms, transform 300ms;
            }

            ${StyledButton}:hover > ${TypographyStyle}::after {
                opacity: 1;
                transform: translate3d(0, 0.2em, 0);
            }

            ${StyledButton} > ${TypographyStyle}::after {
                opacity 1;
                transform: translate3d(-100%, 0, 0);
            }
              
            ${StyledButton}:hover > ${TypographyStyle}::after{
                transform: translate3d(0, 0, 0);
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
